import React from 'react';
import ToolButton, { type ToolButtonProps } from '../toolbars/ToolButton';
import styles from '../styles.module.css';
import { type BaseTool } from '../tools/Tool';

type ToolButtonWithLabelProps = {
  label: string;
} & Partial<ToolButtonProps<typeof BaseTool>>;

const ToolButtonWithLabel: React.FC<ToolButtonWithLabelProps> = ({
  popup,
  tippyRef,
  label,
  children,
}) => {
  return (
    <ToolButton
      className={styles.toolButtonWide}
      style={{ padding: '0 8px 0 8px' }}
      popup={popup}
      tippyRef={tippyRef}
    >
      <div className={styles.toolButtonWithSecondaryText}>
        <span className={styles.toolButtonSecondaryText}>{label}</span>
        {children}
      </div>
    </ToolButton>
  );
};

export default ToolButtonWithLabel;
